var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthersAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28125 1.26941C6.50503 1.04564 6.80853 0.919922 7.125 0.919922C7.44147 0.919922 7.74497 1.04564 7.96875 1.26941C8.19253 1.49319 8.31824 1.7967 8.31824 2.11316C8.31824 2.42963 8.19253 2.73314 7.96875 2.95691L2.625 8.30066L0.375 8.86316L0.9375 6.61316L6.28125 1.26941Z",
    stroke: "#231F20",
    strokeOpacity: 0.82,
    strokeWidth: 0.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersAdd);
export default __webpack_public_path__ + "static/media/othersAdd.15bce75b462d5961b5112bc49b92302c.svg";
export { ForwardRef as ReactComponent };